import { useEffect, useState } from 'react';
import { useAppSelector } from '../store';

//get generic type and put it to [key: string]: any;
export interface MultilanguageState<T = any> {
  [key: string]: T;
}
export interface MultilanguageErrorState {
  [key: string]: boolean;
}


// get generic type  and put it to MultilanguageStateProps
export const useMultilanguageState = <S>(defaultValue?: S) => {
  const languageList = useAppSelector((state) => state.config.languages);
  const [state, setState] = useState<MultilanguageState>({});

  useEffect(() => {
    if (!languageList || languageList.length === 0) return;

    const stateObject: MultilanguageState = {};
    languageList.forEach((lang) => {
      stateObject[lang.LanguageId] = defaultValue || undefined;
    });
    setState(stateObject);
  }, [languageList]);

  function handleStateChange(newState: any) {
    setState(newState);
  }

  const returnVal: [MultilanguageState<S>, (newState: any) => void] = [state, handleStateChange];
  return returnVal;
};
